import React from "react";
import classes from "./UserLandingPage.module.css";
import { DateRangeIcon } from "@mui/x-date-pickers";
import CodeIcon from "@mui/icons-material/Code";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { Clock } from "react-feather";

const AssessmentCard = ({ assessment, onViewAttempts }) => {
  // Max-Attempts-specific: gate on the explicit flag when present; fall back to inferring
  // from maxAttemptsUsed/maxAttemptsHistory for records saved before the flag existed.
  // This intentionally ignores the general, pre-existing `attemptCount` field — browsing
  // "attempt history" only makes sense for quizzes that actually allow multiple attempts.
  const usesAttemptTracking = assessment?.isMaxAttemptsQuiz !== undefined
    ? Boolean(assessment.isMaxAttemptsQuiz)
    : (assessment?.maxAttemptsUsed !== undefined && assessment?.maxAttemptsUsed !== null) &&
      Array.isArray(assessment?.maxAttemptsHistory) && assessment.maxAttemptsHistory.length > 0;
  const attemptCount = assessment?.maxAttemptsUsed || assessment?.maxAttemptsHistory?.length || 0;

  return (
    <>
      <div className={classes.assessmentCaerdCon}>
        <div className="d-flex">
          <p className={classes.assessmentName}>{assessment?.courseTitle}</p>
        </div>
        <div className="d-flex">
          <div>
            <DoneIcon sx={{ color: "#288F58" }} />
          </div>
          <p>Correct: {assessment?.quizResults?.correctQuestions}</p>
        </div>
        <div className="d-flex">
          <div>
            <CloseIcon sx={{ color: "#BC400A" }} />
          </div>
          <p>Incorrect:{assessment?.quizResults?.incorrectQuestions}</p>
        </div>
        <div className={classes.progressMainCon}>
          <p className="mt-3">Percentage Obtained:</p>
          <div className={classes.progressCon}>
            <div className={classes.total}></div>
            <div
              className={classes.progressAmount}
              style={{
                width: `${assessment?.quizResults?.score?.toFixed(0)}%`,
              }}
            ></div>
          </div>
          <div className={classes.percentage}>
            {assessment?.quizResults?.score?.toFixed(0)}%
          </div>
        </div>
        {/* <div className={classes.dateCon}>
          <div>
            <DateRangeIcon />
          </div>
          <p className={classes.date}> 1/01/2024 - 5/01/2024</p>
        </div> */}
        {usesAttemptTracking && (
          <button
            type="button"
            className="btn btn-link btn-sm d-flex align-items-center gap-1 px-0 mt-2"
            onClick={() => onViewAttempts?.(assessment)}
          >
            <Clock size={14} />
            View Attempt History ({attemptCount})
          </button>
        )}
      </div>
    </>
  );
};

export default AssessmentCard;
